var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',[_c('autocompleteOneForm',{attrs:{"label":"Empresa","loading":_vm.loadingCompanies,"valueInput":_vm.values.company_id,"rule":_vm.rules.required,"items":_vm.serverItems.company,"errorMessages":_vm.serverErrors.company_id},on:{"valueChange":(v) => {
                        _vm.values.company_id = v;
                        _vm.getEmployeeByBusiness(v);
                        delete _vm.serverErrors.company_id;
                    }}})],1)],1),_c('v-row',[_c('v-col',[_c('autocompleteOneForm',{attrs:{"label":"Colaborador","loading":_vm.loadingEmployees,"valueInput":_vm.values.employeeId,"rule":_vm.rules.required,"items":_vm.serverItems.employees,"errorMessages":_vm.serverErrors.employeeId},on:{"valueChange":(v) => {
                        _vm.values.employeeId = v;
                        delete _vm.serverErrors.employeeId;
                    }}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }